/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import TreeNode from "App/utils/globe/chunk_lod/tree/node";

export enum VisitorOrdering {
    pre = "pre",
    post = "post"
}

export enum VisitorDirection {
    down = "down",
    up = "up"
}

/**
 * Abstract class for implementing the node tree visitor
 */
export default
class Visitor {
    protected _ordering: VisitorOrdering;
    protected _direction: VisitorDirection;
    protected _visiteeConsumerFunction: (TreeNode) => boolean;

    constructor() {
        this._ordering = VisitorOrdering.post;
        this._direction = VisitorDirection.down;
        this._visiteeConsumerFunction = null;
    }

    public init(aOrdering: VisitorOrdering, aDirection: VisitorDirection, aVisiteeConsumerFunction: (TreeNode) => boolean) {
        this._ordering = aOrdering;
        this._direction = aDirection;
        this._visiteeConsumerFunction = aVisiteeConsumerFunction;
    }

    public visit(aVisitee: TreeNode): boolean {
        if (this._visiteeConsumerFunction) {
            return this._visiteeConsumerFunction(aVisitee);
        }

        return true;
    }

    public getOrdering(): VisitorOrdering {
        return this._ordering;
    }

    public getDirection(): VisitorDirection {
        return this._direction;
    }

    public getVisiteeConsumerFunction(): (TreeNode) => boolean {
        return this._visiteeConsumerFunction;
    }
}
